import { render } from "./UISearchForm.vue?vue&type=template&id=4b9892c2"
import script from "./UISearchForm.vue?vue&type=script&lang=js"
export * from "./UISearchForm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__